import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo.js';
import MobileMenu from './MobileMenu';

const SimpleNavbar = () => {
  const location = useLocation();

  const navItems = [
    { label: 'Platform', href: '/platform' },
    { label: 'Solutions', href: '/use-cases' },
    { label: 'Use Cases', href: '/use-cases' },
    { label: 'Company', href: '/company' },
    { label: 'Resources', href: '/resources' }
  ];

  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="sticky top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur-sm shadow-sm w-full"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Logo />
            <MobileMenu navItems={navItems} />
          </div>
          <button
            className="px-5 py-2 text-white font-semibold bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors"
            onClick={() => window.open('https://dspm.ancile.ai')}
          >
            Get Demo
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default SimpleNavbar; 